import { format, isSameMonth, isToday, isWeekend } from 'date-fns';
import { lighten } from 'polished';
import React, { useState } from 'react';
import { uuid } from '../../../../CodesThatsGottaGoSomewhereElse';
import { LFC } from '../../../../Legacy';
import { Colors } from '../../../../ui';
import { RenderBox, RenderSvg } from '../../../canvas/visualization/RenderHelpers';
import { CalendarFrameAddon } from './CalendarFrameAddon';

const headStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '36px',
    fontWeight: '36px',
};

const cellStyle = (sameMonth: boolean, today: boolean) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: '10px',
    fontSize: '24px',
    fontWeight: '36px',
    color: sameMonth ? Colors.text : Colors.textLighter,
    backgroundColor: sameMonth ? '#fff' : 'rgba(255,255,255,0.33)',
});

export const CalendarFrameAddonVisual: LFC<{ object: CalendarFrameAddon }> = ({ object }) => {
    const { base, head, body } = object.layout;

    const [[g1]] = useState([uuid(), uuid(), uuid()]);

    const headers = object.headers;
    const headerStops = headers.flatMap((x, i) => [
        {
            id: `${x}1`,
            offset: `${(i / headers.length) * 100}%`,
            stopColor: lighten(.02 * i, object.color || Colors.primary),
        },
        {
            id: `${x}2`,
            offset: `${((i + 1) / headers.length) * 100}%`,
            stopColor: lighten(.02 * i, object.color || Colors.primary),
        }
    ]);

    return <>
        <RenderSvg area={head.area}>
            <defs>
                <linearGradient id={g1} x1="0" x2="0" y1="0" y2="1">
                    {headerStops.map(x => <stop key={x.id} {...x} />)}
                </linearGradient>
            </defs>
            <g>
                <rect width="100%" height="100%" fill={`url(#${g1})`} />
            </g>
        </RenderSvg>
        {head.month.area.area() > 0 && head.month.cells.map(x =>
            <RenderBox key={x.date.getTime()} {...x.area.toCSS()} {...headStyle} color={Colors.contrastTextColorFor(object.color)}>
                {format(x.date, 'MMMM yyyy')}
            </RenderBox>
        )}
        {head.days.area.area() > 0 && head.days.cells.map(x =>
            <RenderBox key={x.date.getTime()} {...x.area.toCSS()} {...headStyle} color={Colors.contrastTextColorFor(object.color)}>
                {format(x.date, 'E')}
            </RenderBox>
        )}
        {body.cells.map(x =>
            <RenderBox key={x.date.getTime()} {...x.area.inflate(-3).toCSS()} {...cellStyle(isSameMonth(x.date, object.from) && !isWeekend(x.date), isToday(x.date))}>
                {isToday(x.date) ? <>
                    <RenderBox position="relative" backgroundColor={Colors.primary} padding="5px 10px" borderRadius="1000px" color="white">
                        {format(x.date, 'dd')}
                    </RenderBox>
                </> : <>
                    {format(x.date, 'dd')}
                </>}
            </RenderBox>
        )}
    </>;
};
